// Imports
import axios from "axios";
import { updateMeters } from "../../meter/api/actions";
import { GET, POST, PUT, DEL } from "../../genericAPI/api/actions";

import "../../../setup/config/apiConfig";

// Actions Types
export const ACCOUNT_OBJECT_RESET = "ACCOUNT_OBJECT_RESET";
export const UPDATE_CLIENT_ACCOUNT_OBJECT = "UPDATE_CLIENT_ACCOUNT_OBJECT";
export const UPDATE_ACCOUNT_NOTES_ARRAY = "UPDATE_ACCOUNT_NOTES_ARRAY";

export const GET_ACCOUNT_BALANCE_REQUEST = "GET_ACCOUNT_BALANCE_REQUEST";
export const GET_ACCOUNT_BALANCE_RESPONSE = "GET_ACCOUNT_BALANCE_RESPONSE";

export const UPDATE_ACCOUNT_REQUEST = "HANDLE_GET_ACCOUNT_REQUEST";
export const UPDATE_ACCOUNT_RESPONSE = "HANDLE_GET_ACCOUNT_RESPONSE";

export const GET_ACCOUNT_REQUEST = "HANDLE_GET_ACCOUNT_REQUEST";
export const GET_ACCOUNT_RESPONSE = "HANDLE_GET_ACCOUNT_RESPONSE";
export const GET_ACCOUNT_FAILURE = "HANDLE_GET_ACCOUNT_FAILURE";

export const CREATE_ADDRESS_REQUEST = "CREATE_ADDRESS_REQUEST";
export const CREATE_ADDRESS_RESPONSE = "CREATE_ADDRESS_RESPONSE";
export const CREATE_ADDRESS_FAILURE = "CREATE_ADDRESS_FAILURE";

export const UPDATE_ADDRESS_REQUEST = "UPDATE_ADDRESS_REQUEST";
export const UPDATE_ADDRESS_RESPONSE = "UPDATE_ADDRESS_RESPONSE";
export const UPDATE_ADDRESS_FAILURE = "UPDATE_ADDRESS_FAILURE";

export const DELETE_ADDRESS_REQUEST = "DELETE_ADDRESS_REQUEST";
export const DELETE_ADDRESS_RESPONSE = "DELETE_ADDRESS_RESPONSE";
export const DELETE_ADDRESS_FAILURE = "DELETE_ADDRESS_FAILURE";

export const GET_ACCOUNT_BY_ACCTNUM_REQ = "GET_ACCOUNT_BY_ACCTNUM_REQ";
export const GET_ACCOUNT_BY_ACCTNUM_RESP = "GET_ACCOUNT_BY_ACCTNUM_RESP";
export const GET_ACCOUNT_BY_ACCTNUM_FAILURE = "GET_ACCOUNT_BY_ACCTNUM_FAILURE";

export const GET_ACCOUNT_LEDGER_REQUEST = "GET_ACCOUNT_LEDGER_REQUEST";
export const GET_ACCOUNT_LEDGER_RESPONSE = "GET_ACCOUNT_LEDGER_RESPONSE";
export const GET_ACCOUNT_LEDGER_FAILURE = "GET_ACCOUNT_LEDGER_FAILURE";
export const UPDATE_CLIENT_ACCOUNT_LEDGER = "UPDATE_CLIENT_ACCOUNT_LEDGER";

export const REFRESH_CLIENT_ACCOUNT_BALANCE = "REFRESH_CLIENT_ACCOUNT_BALANCE";

export const HYDRATE_ACCOUNT_REQUEST = "HYDRATE_ACCOUNT_REQUEST";
export const HYDRATE_ACCOUNT_RESPONSE = "HYDRATE_ACCOUNT_RESPONSE";

export const UPDATE_LOOKED_UP_METER = "UPDATE_LOOKED_UP_METER";
export const METER_HISTORY_LOOKUP_REQUEST = "METER_HISTORY_LOOKUP_REQUEST";
export const METER_HISTORY_LOOKUP_RESPONSE = "METER_HISTORY_LOOKUP_RESPONSE";
export const RESET_METER_ACCOUNT_READINGS = "RESET_METER_ACCOUNT_READINGS";

export const DELETE_ACCOUNT_REQUEST = "DELETE_ACCOUNT_REQUEST";
export const DELETE_ACCOUNT_RESPONSE = "DELETE_ACCOUNT_RESPONSE";
export const DELETE_ACCOUNT_FAILURE = "DELETE_ACCOUNT_FAILURE";

export const UPDATE_ACCOUNT_DISCOUNT_REQUEST = "UPDATE_ACCOUNT_DISCOUNT_REQUEST";
export const UPDATE_ACCOUNT_DISCOUNT_RESPONSE = "UPDATE_ACCOUNT_DISCOUNT_RESPONSE";
export const UPDATE_ACCOUNT_DISCOUNT_FAILURE = "UPDATE_ACCOUNT_DISCOUNT_FAILURE";

export const GET_WINTER_CRISIS_HISTORY_REQUEST = "GET_WINTER_CRISIS_HISTORY_REQUEST";
export const GET_WINTER_CRISIS_HISTORY_RESPONSE = "GET_WINTER_CRISIS_HISTORY_RESPONSE";
export const GET_WINTER_CRISIS_HISTORY_FAILURE = "GET_WINTER_CRISIS_HISTORY_FAILURE";
export const CREATE_WINTER_CRISIS_HISTORY_REQUEST = "CREATE_WINTER_CRISIS_HISTORY_REQUEST";
export const CREATE_WINTER_CRISIS_HISTORY_RESPONSE = "CREATE_WINTER_CRISIS_HISTORY_RESPONSE";
export const CREATE_WINTER_CRISIS_HISTORY_FAILURE = "CREATE_WINTER_CRISIS_HISTORY_FAILURE";
export const CHECK_WINTER_CRISIS_AVAILABILITY_REQUEST = "CHECK_WINTER_CRISIS_AVAILABILITY_REQUEST";
export const CHECK_WINTER_CRISIS_AVAILABILITY_RESPONSE = "CHECK_WINTER_CRISIS_AVAILABILITY_RESPONSE";
export const CHECK_WINTER_CRISIS_AVAILABILITY_FAILURE = "CHECK_WINTER_CRISIS_AVAILABILITY_FAILURE";
export const UPDATE_PLEDGE_ACCOUNT_STATE = "UPDATE_PLEDGE_ACCOUNT_STATE";

export const GET_MED_FORM_HISTORY_REQUEST = "GET_MED_FORM_HISTORY_REQUEST";
export const GET_MED_FORM_HISTORY_RESPONSE = "GET_MED_FORM_HISTORY_RESPONSE";
export const GET_MED_FORM_HISTORY_FAILURE = "GET_MED_FORM_HISTORY_FAILURE";
export const DELETE_MED_FORM_HISTORY_REQUEST = "DELETE_MED_FORM_HISTORY_REQUEST";
export const DELETE_MED_FORM_HISTORY_RESPONSE = "DELETE_MED_FORM_HISTORY_RESPONSE";
export const DELETE_MED_FORM_HISTORY_FAILURE = "DELETE_MED_FORM_HISTORY_FAILURE";

export const GET_PLEDGE_HISTORY_REQUEST = "GET_PLEDGE_HISTORY_REQUEST";
export const GET_PLEDGE_HISTORY_RESPONSE = "GET_PLEDGE_HISTORY_RESPONSE";
export const GET_PLEDGE_HISTORY_FAILURE = "GET_PLEDGE_HISTORY_FAILURE";

export const CREATE_PLEDGE_HISTORY_REQUEST = "CREATE_PLEDGE_HISTORY_REQUEST";
export const CREATE_PLEDGE_HISTORY_RESPONSE = "CREATE_PLEDGE_HISTORY_RESPONSE";
export const CREATE_PLEDGE_HISTORY_FAILURE = "CREATE_PLEDGE_HISTORY_FAILURE";

export const UPDATE_PLEDGE_HISTORY_REQUEST = "UPDATE_PLEDGE_HISTORY_REQUEST";
export const UPDATE_PLEDGE_HISTORY_RESPONSE = "UPDATE_PLEDGE_HISTORY_RESPONSE";
export const UPDATE_PLEDGE_HISTORY_FAILURE = "UPDATE_PLEDGE_HISTORY_FAILURE";

export const DELETE_PLEDGE_HISTORY_REQUEST = "DELETE_PLEDGE_HISTORY_REQUEST";
export const DELETE_PLEDGE_HISTORY_RESPONSE = "DELETE_PLEDGE_HISTORY_RESPONSE";
export const DELETE_PLEDGE_HISTORY_FAILURE = "DELETE_PLEDGE_HISTORY_FAILURE";

export function updateSelectedAccount(newAccountObject) {
  return { type: UPDATE_CLIENT_ACCOUNT_OBJECT, newAccountObject };
}
export function refreshSelectedAccountBalance(newBalanceObject) {
  return { type: REFRESH_CLIENT_ACCOUNT_BALANCE, newBalanceObject };
}
export function updateAccountNotes(notesArray) {
  return { type: UPDATE_ACCOUNT_NOTES_ARRAY, notesArray };
}
export function updateAccountLedger(newAccountLedger) {
  return { type: UPDATE_CLIENT_ACCOUNT_LEDGER, newAccountLedger };
}
export function updateLookedUpAccountMeter(newMeterHistory, meterId) {
  const items = Array.isArray(newMeterHistory)
    ? newMeterHistory
    : Array.isArray(newMeterHistory?.items)
      ? newMeterHistory.items
      : [];
  return { type: UPDATE_LOOKED_UP_METER, newMeterHistory: items, meterId };
}

export function updateAccountAddress(forwardingAddress) {
  // Extract uuid for URL
  const uuid = forwardingAddress.uuid;
  
  // Filter out read-only fields that shouldn't be in the update body
  // Only include editable fields: accountId, addressType, and address fields
  const updateBody = {
    accountId: forwardingAddress.accountId,
    addressType: forwardingAddress.addressType,
    address1: forwardingAddress.address1 || "",
    address2: forwardingAddress.address2 || "",
    city: forwardingAddress.city || "",
    state: forwardingAddress.state || "",
    zip: forwardingAddress.zip || "",
  };
  
  return PUT("accountaddress", uuid, updateBody, UPDATE_ADDRESS_REQUEST, UPDATE_ADDRESS_RESPONSE, UPDATE_ADDRESS_FAILURE);
}

export function updatePledgeAccountItemsState(items) {
  return { type: UPDATE_PLEDGE_ACCOUNT_STATE, items };
}

export function createNewAccountAddress(forwardingAddress) {
  return POST("accountaddress", "", forwardingAddress, CREATE_ADDRESS_REQUEST, CREATE_ADDRESS_RESPONSE, CREATE_ADDRESS_FAILURE
  );
}

export function deleteForwardingAddress(forwardingAddress) {
  return DEL("accountaddress", forwardingAddress.uuid, DELETE_ADDRESS_REQUEST, DELETE_ADDRESS_RESPONSE, DELETE_ADDRESS_FAILURE);
}

// Actions
export function getAccountInfoByAccountUUID(accountUUID, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_ACCOUNT_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get("/account/" + accountUUID)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch(updateSelectedAccount(response.data));
          dispatch({
            type: GET_ACCOUNT_RESPONSE,
            isLoading: false,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: GET_ACCOUNT_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_ACCOUNT_RESPONSE,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function getAccountByAccountNumber(accountNumber) {
  return POST("account/fullpreview/batch/acct-numbers", "", { accountNums: [accountNumber] }, GET_ACCOUNT_BY_ACCTNUM_REQ, GET_ACCOUNT_BY_ACCTNUM_RESP, GET_ACCOUNT_BY_ACCTNUM_FAILURE);
}


export function lookupAccountMeterHistory(meterId, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: METER_HISTORY_LOOKUP_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get("/meterreading/meter/" + meterId)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch(updateLookedUpAccountMeter(response.data, meterId));
          dispatch({
            type: METER_HISTORY_LOOKUP_RESPONSE,
            isLoading: false,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: METER_HISTORY_LOOKUP_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: METER_HISTORY_LOOKUP_RESPONSE,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function getAccountBalance(accountId, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_ACCOUNT_BALANCE_REQUEST,
      isLoading,
    });
    return axios
      .get("/accountbalance/account/" + accountId)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }

        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch(refreshSelectedAccountBalance(response.data));
          dispatch({
            type: GET_ACCOUNT_BALANCE_RESPONSE,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: GET_ACCOUNT_BALANCE_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_ACCOUNT_BALANCE_RESPONSE,
          error: error,
        });
      });
  };
}

export function getAccountLedger(accountNumber, ledgerIsLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_ACCOUNT_LEDGER_REQUEST,
      ledgerIsLoading,
    });
    return axios
      .get("/accountledger/account/" + accountNumber)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }

        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch(updateAccountLedger(response.data));
          dispatch({
            type: GET_ACCOUNT_LEDGER_RESPONSE,
            ledgerError: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: GET_ACCOUNT_LEDGER_RESPONSE,
            ledgerIsLoading: false,
            ledgerError: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_ACCOUNT_LEDGER_FAILURE,
          ledgerIsLoading: false,
          ledgerError: "Error: UNKNOWN",
        });
      });
  };
}

export function hydrateAccount(accountUUID, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: HYDRATE_ACCOUNT_REQUEST,
      isLoading,
    });
    return axios
      .get("/account/hydrate/" + accountUUID)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch(updateSelectedAccount(response.data));
          // If a unit meter or meters are found, look up all the meter reading history for those meters:
          if (
            response.data.unit &&
            response.data.unit.meters &&
            response.data.unit.meters.length > 0
          ) {
            dispatch(updateMeters(response.data.unit.meters));
            dispatch({
              type: RESET_METER_ACCOUNT_READINGS,
            });
            response.data.unit.meters.map((meter) => {
              dispatch(lookupAccountMeterHistory(meter.id));
            });
          }
          dispatch({
            type: HYDRATE_ACCOUNT_RESPONSE,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: HYDRATE_ACCOUNT_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: HYDRATE_ACCOUNT_RESPONSE,
          error: error,
        });
      });
  };
}

export function deleteAccounts(accountUUIDs, isLoading = true) {
  const payload = { uuids: accountUUIDs };
  return (dispatch) => {
    dispatch({
      type: DELETE_ACCOUNT_REQUEST,
      isLoading,
    });
    return axios.
      post("/accounts-delete/", payload).then((response) => 
      {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: DELETE_ACCOUNT_RESPONSE,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: DELETE_ACCOUNT_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      }).catch((error) => {
        dispatch({
          type: DELETE_ACCOUNT_RESPONSE,
          error: error,
        });
       });
  }
}
export function updateDisconnectAccountsforUnit(accountUuid, disconnected, isLoading = false){
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACCOUNT_DISCOUNT_REQUEST,
      isLoading,
    });
    return axios
      .put("/account/update-disconnects/" + accountUuid, {disconnected: disconnected})
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: UPDATE_ACCOUNT_DISCOUNT_RESPONSE,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: UPDATE_ACCOUNT_DISCOUNT_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_ACCOUNT_DISCOUNT_RESPONSE,
          error: error,
        });
      });
  }
}

export function updateCurrentAccountInDB(updatedAccount, isLoading = false) {
  console.log("updatedAccount");
  console.log(updatedAccount);
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACCOUNT_REQUEST,
      isLoading,
    });
    return axios
      .put("/account/" + updatedAccount.uuid, updatedAccount)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: UPDATE_ACCOUNT_RESPONSE,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: UPDATE_ACCOUNT_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        //console.log(error);
        dispatch({
          type: UPDATE_ACCOUNT_RESPONSE,
          error: error,
        });
      });
  };
}

export function refreshLookedUpAccountMeters(data) {
  return (dispatch) => {
    dispatch({
      type: METER_HISTORY_LOOKUP_REQUEST,
      isLoading: true,
    });
    // If a unit meter or meters are found, look up all the meter reading history for those meters:
    if (data.unit && data.unit.meters && data.unit.meters.length > 0) {
      data.unit.meters.map((meter) => {
        dispatch(lookupAccountMeterHistory(meter.id));
      });
      dispatch({
        type: METER_HISTORY_LOOKUP_RESPONSE,
      });
    }
  };
}
export function getMedFormHistoryForAccount(accountNumber){
  return (dispatch) => {
    dispatch({
      type: GET_MED_FORM_HISTORY_REQUEST,
      isLoading: true,
    });
    return axios
      .get(`/medformhistory/account/${accountNumber}`)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: GET_MED_FORM_HISTORY_RESPONSE,
            medFormHistory: response.data || [],
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: GET_MED_FORM_HISTORY_RESPONSE,
            medFormHistory: [],
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_MED_FORM_HISTORY_FAILURE,
          error: error,
        });
      });
  };
}

export function deleteMedFormHistory(medFormHistoryUuid) {
  return DEL(
    "medformhistory",
    medFormHistoryUuid,
    DELETE_MED_FORM_HISTORY_REQUEST,
    DELETE_MED_FORM_HISTORY_RESPONSE,
    DELETE_MED_FORM_HISTORY_FAILURE
  );
}

export function getWinterCrisisHistoryForAccount(accountNumber){
  return (dispatch) => {
    dispatch({
      type: GET_WINTER_CRISIS_HISTORY_REQUEST,
      isLoading: true,
    });
    return axios
      .get(`/wintercrisishistory/account/${accountNumber}`)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: GET_WINTER_CRISIS_HISTORY_RESPONSE,
            winterCrisisHistory: response.data || [],
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: GET_WINTER_CRISIS_HISTORY_RESPONSE,
            winterCrisisHistory: [],
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_WINTER_CRISIS_HISTORY_FAILURE,
          error: error,
        });
      });
  };
}
export function createWinterCrisisHistory(coverAmount, accountNumber){
  return (dispatch) => {
    dispatch({
      type: CREATE_WINTER_CRISIS_HISTORY_REQUEST,
      isLoading: true,
    });
    
    const body = {
      coverAmount: coverAmount,
      accountNumber: accountNumber,
    };
    
    return axios
      .post(`/wintercrisishistory`, body)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: CREATE_WINTER_CRISIS_HISTORY_RESPONSE,
            winterCrisisHistory: response.data || null,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: CREATE_WINTER_CRISIS_HISTORY_RESPONSE,
            winterCrisisHistory: null,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: CREATE_WINTER_CRISIS_HISTORY_FAILURE,
          error: error,
        });
      });
  };
}

export function checkWinterCrisisAvailability(accountNumber){
  return (dispatch) => {
    dispatch({
      type: CHECK_WINTER_CRISIS_AVAILABILITY_REQUEST,
      isLoading: true,
    });
    return axios
      .get(`/wintercrisishistory/active/${accountNumber}`)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: CHECK_WINTER_CRISIS_AVAILABILITY_RESPONSE,
            winterCrisisAvailable: response.data?.isActive === false, // Available only if NOT active
            isActive: response.data?.isActive || false,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: CHECK_WINTER_CRISIS_AVAILABILITY_RESPONSE,
            winterCrisisAvailable: false,
            isActive: false,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: CHECK_WINTER_CRISIS_AVAILABILITY_FAILURE,
          error: error,
        });
      });
  };
}

export function getPledgeHistory(accountNum) {
  return GET("pledgeHistory", accountNum, GET_PLEDGE_HISTORY_REQUEST, GET_PLEDGE_HISTORY_RESPONSE, GET_PLEDGE_HISTORY_FAILURE);
}
export function createPledgeHistory(pledgeHistory, accountNum) {
  return POST(`pledgeHistory`, accountNum, pledgeHistory, CREATE_PLEDGE_HISTORY_REQUEST, CREATE_PLEDGE_HISTORY_RESPONSE, CREATE_PLEDGE_HISTORY_FAILURE);
}
export function updatePledgeHistory(pledgeHistory, pledgeHistoryUuid) {
  return PUT("pledgeHistory", pledgeHistoryUuid, pledgeHistory, UPDATE_PLEDGE_HISTORY_REQUEST, UPDATE_PLEDGE_HISTORY_RESPONSE, UPDATE_PLEDGE_HISTORY_FAILURE);
}
export function deletePledgeHistory(pledgeHistoryUuid) {
  return DEL("pledgeHistory", pledgeHistoryUuid, "", DELETE_PLEDGE_HISTORY_REQUEST, DELETE_PLEDGE_HISTORY_RESPONSE, DELETE_PLEDGE_HISTORY_FAILURE);
}

